import React from 'react'

const Footer = () => {
  return (
    <div className='flex justify-center bg-purple-700 pb-2 text-lg font-semibold text-white'>
      <p>Made With ❤️ && ☕ by Nilesh Nj </p>
    </div>
  )
}

export default Footer;